import React from "react";
import { Button } from "reactstrap";

export default function DispatchRequestCard({ request, onHandle }) {
    const isTimeout = request.dispatchReason === "TimedOut";
    const isClaimed = request.acceptedBy != null;

    return (
        <div style={{ padding: "4px 0" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                    <span style={{ 
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        padding: "1px 6px",
                        borderRadius: "3px",
                        fontSize: "10px",
                        fontWeight: "bold"
                    }}>
                        {isTimeout ? "TIMEOUT" : "911 REQUEST"}
                    </span>
                    <div style={{ fontSize: "12px", marginTop: "2px", fontWeight: "bold" }}>
                        {request.elevatorName}
                    </div>
                </div>
                <Button 
                    color="primary"
                    style={{ 
                        padding: "0 12px", 
                        fontSize: "12px", 
                        height: "28px",
                        minWidth: "auto",
                        lineHeight: "26px"
                    }}
                    onClick={() => onHandle(request)}
                >
                    {isClaimed ? "Continue" : "Handle"}
                </Button>
            </div>
        </div>
    );
}
